import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../config');

class ModalAuthorization extends Component{
	constructor(props){
		super(props);

		this.handleClose = this.handleClose.bind(this);
		this.handleShow  = this.handleShow.bind(this);
		this.confirmation= this.confirmation.bind(this);
		this.removeRefuse= this.removeRefuse.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.state = {
			show: false,
			password:"",
			reasons: [],
			reason: "",
			type:""
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleClose(){
		this.setState({ 
			show:false,
			password:"",
			reason:"",
			reasons:[],
			//type:""
		});
	}

	handleShow(type){
		if(type === 'clinic'){
			this.setState({type:''});
		}
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'lookups?type=ANULAR_REJECTION_REASONS&option=actives&order=true',{
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();

			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					reasons: response,
					show:true,
					password:"",
					type:type
				});
			}
		});

	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		if(e.target.value === ""){
			document.getElementById(e.target.name).classList.remove('error');
		}else{
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	confirmation(){
		if(this.isValidForm()){
			var password = btoa(this.state.password);
			password = password.split("").reverse().join("");
			
			//var id_refuse = this.props.id_refuse;
			
			fetch(Config.default.apiGateway.URL+'incidents_refused?password='+password, {
				method :'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			})
			.then(res => {
				if(res.ok){
					return res.json();
				}
			})
			.then(response =>{
				if(response.res){
					this.handleClose();
					this.removeRefuse(this.props.id_refuse);

				}else{
					swal("Error", "La Contraseña es incorrecta", 'error');
					this.setState({
						password:""
					})
				}
			})
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}

	}

	isValidForm() {
		const select = document.querySelector('div.modal-body');
  		const inputs = select.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
    			const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
	    		
	    		
			      			   
		  	}
	    });
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	removeRefuse(id){
		
		fetch(Config.default.apiGateway.URL+'incidents_refused/'+id,{
			method : 'put',
			body:JSON.stringify({release_reason:this.state.reason}),
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type' 	: 'application/json'
			}),
		})
		.then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(result) {
	                swal('¡Error!', result, 'error');
	            });
			}
		})
		.then(function(res){
			if(res !== undefined){
				this.handleClose();
				
				swal("Bien hecho", "El candado fue eliminado correctamente", 'success');	
				
				if(this.state.type === 'clinic'){
					this.props.closing();
				}else{
					this.props.refresh();
				}
				
				
			}
		}.bind(this));
	}

	render(){
		const {t} = this.props;

		return (
			<Modal show={this.state.show} onHide={this.handleClose} >
				<Modal.Header closeButton>
					<Modal.Title>Confirmación</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-xs-12 form-group">
							<div className="col-xs-12 col-sm-6 col-sm-offset-3">
								<span className="span-min">Motivo de Liberación</span>
								<select className="form-control" id="reason" name="reason" value={this.state.reason}
									onChange={this.handleChange} required>
									<option value="">Seleccione...</option>
									{this.state.reasons.map((r, i)=>{
										return <option key={i} value={r.key}>
											{r.name}
										</option>
									})}
								</select>
							</div>
						</div>
						<hr style={{width:"90%"}} />
						<div className="col-xs-12">
							<div className="col-xs-12 col-sm-6 col-sm-offset-3">
								<input className="form-control"
									type="password"
									name='password'
									id='password'
									value={this.state.password}
									onChange={this.handleChange}
									autoFocus
									required
									autoComplete="off"
									placeholder="Contraseña de confirmación" />
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.confirm')}  onClick={this.confirmation}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
			</Modal>
		)
	}
}

export default translate('translations')(ModalAuthorization)